module.exports = __webpack_public_path__ + "static/media/student-study-comment.fa283aa0.png";